import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Select } from 'components/ui/select';
import { loadObject, search } from './api';

export default function QuickbooksSelect({ type, onChange, quickbooksId, ...props }) {
  const [loadedValue, setLoadedValue] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!quickbooksId) return;
    setIsLoading(true);
    loadObject({ type, id: quickbooksId }, (result) => {
      setLoadedValue(result);
      setIsLoading(false);
    });
  }, [type, quickbooksId]);

  const searchEntities = useCallback((searchQuery, callback) => {
    const params = { displayName: searchQuery };
    params.type = type;
    search(
      params,
      callback,
    );
  }, [type]);

  return (
    <Select
      {...props}
      aria-label="search"
      getOptionLabel={entity => entity.displayName}
      getOptionValue={entity => entity.id}
      isClearable
      isLoading={isLoading}
      loadOptions={searchEntities}
      menuPlacement="top"
      placeholder={`Enter QuickBooks ${type} name`}
      value={loadedValue}
      onChange={(result) => {
        setLoadedValue(result);
        onChange(result);
      }}
    />
  );
}

QuickbooksSelect.propTypes = {
  quickbooksId: PropTypes.number,
  type: PropTypes.oneOf(['customer', 'vendor']).isRequired,
  onChange: PropTypes.func.isRequired
};
